<template>
  <div
  class="TransferItem"
  :class="{'TransferItem--hidden': hidden}">
    <div class="TransferItem__row">
      <span class="TransferItem__name">
        {{ item.name }}
      </span>
      <span
      v-if="progress.loaded && progress.total"
      class="TransferItem__value">
        {{ sizeToString(progress.loaded)}}/{{sizeToString(progress.total)}}
      </span>
    </div>
    <div class="TransferItem__row">
      <div class="TransferItem__bar">
        <div
        v-if="progress.percent"
        :style="{ width: `${progress.percent}%`}"
        class="TransferItem__progress"/>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import { Message } from 'element-ui'

import SizeMixin from '@/components/mixins/Size.mixin'

export default {
  name: 'TransferItem',

  mixins: [
    SizeMixin
  ],

  props: {
    item: {
      type: Object,
      required: true,
      validator (item) {
        return item.id && item.name
      }
    },
    purpose: {
      type: String,
      required: true,
      validator (purpose) {
        const actions = ['download', 'upload']
        return actions.includes(purpose)
      }
    }
  },

  data () {
    return {
      progress: {
        loaded: null,
        total: null,
        percent: null
      }
    }
  },

  computed: {
    hidden () {
      return this.progress && this.progress.percent === 100
    }
  },

  watch: {
    hidden (value) {
      if (value) {
        setTimeout(() => {
          if (this.purpose === 'upload') {
            this.removeFileUploadById(this.item.id)
          } else if (this.purpose === 'download') {
            this.removeFileDownloadById(this.item.id)
          }
        }, 1000)
      }
    }
  },

  mounted () {
    switch (this.purpose) {
      case 'download':
        this.downloadFile(this.item)
        break
      case 'upload':
        this.uploadFile(this.item)
        break
      default:
        Message({
          type: 'error',
          message: `Oops, this action couldn't be processed`,
          showClose: true
        })
        break
    }
  },

  methods: {
    ...mapActions('files', [
      'downloadFilePromise',
      'putFileStatus'
    ]),
    ...mapActions('filesTransfer', [
      'removeFileUploadById',
      'removeFileDownloadById'
    ]),
    prepareDownloadUrl (item) {
      this.downloadFilePromise(item)
        .then((presignedUrl) => {
          item.downloadUrl = presignedUrl
          this.downloadFile(item)
        }).catch(() => {
          Message({
            type: 'error',
            message: 'Oops, we were unable to download this file',
            showClose: true
          })
        })
    },
    downloadFile (item) {
      const name = item.name
      const that = this
      if (!item.size) return

      if (!item.downloadUrl) {
        this.prepareDownloadUrl(item)
        return
      }

      Vue.http.get(item.downloadUrl, {
        responseType: 'blob',
        progress (e) {
          that.tranferProgres(e)
        }
      }).then(({ body, headers }) => {
        const type = headers.get('content-type')
        const file = new Blob([body], { type })
        const link = document.createElement('a')
        link.download = name
        link.href = window.URL.createObjectURL(file)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(() => {
        Message({
          type: 'error',
          message: 'Oops, we were unable to download this file',
          showClose: true
        })
      })
    },
    uploadFile (item) {
      const that = this
      Vue.http.put(item.presignedUrl, item.file, {
        headers: { 'Content-Type': item.file.type },
        responseType: 'arraybuffer',
        progress (e) {
          that.tranferProgres(e)
        }
      }).then(() => {
        item.file = undefined
        item.presignedUrl = undefined
        this.putFileStatus(item)
      }).catch(() => {
        Message({
          type: 'error',
          message: 'Oops, we were unable to upload your file',
          showClose: true
        })
      })
    },
    tranferProgres (e) {
      if (e.loaded && e.total) {
        this.progress.loaded = e.loaded
        this.progress.total = e.total
        this.progress.percent = Math.ceil((e.loaded / e.total) * 100)
      }
    }
  }

}
</script>

<style lang="scss">
@import 'TransferItem';
</style>
